/**
 * The mark on the two head tags the SEO server decides (web plan W1.3): the
 * canonical `<link>` and the robots `<meta>` carry `data-seo-server`, in the
 * W1 server's injected head (server/head.mjs) and in the framework document's
 * (`headMeta`, @/seo/documentHead), which stay byte-for-byte alike.
 *
 * Nothing in the browser reads the mark any more (web plan W5.1): in the data
 * router, PageHead renders no head on the served URL so the server's tags stand.
 * In fallback mode (plain BrowserRouter, useServesDocumentHead()=false), PageHead
 * renders alongside the server's tags.
 */

/** The attribute the server puts on the canonical `<link>` and the robots `<meta>`. */
export const SERVER_HEAD_ATTRIBUTE = 'data-seo-server';
